import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoEnvio() {
  return (
    <ArtigoPlaceholder
      title="Dicas de Envio Internacional: Como Receber seus Produtos CSSBuy Mais Rápido"
      desc="Compare métodos de envio da China para Portugal e Brasil. Prazos, custos e rastreamento. Escolha a melhor opção para cada tipo de produto."
      icon="ri-ship-line"
      slug="artigo-cssbuy-envio"
    />
  );
}